import { useNavigate } from "react-router-dom";
import { Lock, Sparkles, Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/Shared";
import { Button } from "@/components/ui/button";
import { tiene, minimo, NOMBRE_PLAN } from "@/lib/plan";

const INFO = {
  fichaje: ["Control de fichaje", ["Tus trabajadores fichan desde el móvil con GPS", "Horarios, avisos de retraso y mapa en vivo", "Informes mensuales de horas para tu gestoría"]],
  agenda: ["Agenda de visitas", ["Organiza tus visitas con aviso sonoro", "Recordatorio automático al cliente el día antes", "Convierte una visita en presupuesto o factura"]],
  envios: ["Panel de envíos", ["Historial de emails y WhatsApp enviados a tus clientes", "Filtra los envíos por cliente", "Todo en un mismo panel"]],
  morosidad: ["Informe de morosidad", ["Clientes con facturas pendientes y vencidas", "Importe pendiente de cada cliente", "Recordatorios de cobro automáticos"]],
  certificaciones: ["Certificaciones de Obra", ["Certifica el avance real de las partidas de cada presupuesto", "Factura lo certificado cuando esté firmado y sellado", "Revisa y paga las certificaciones de tus subcontratas"]],
  secretaria: ["Nuvli · Tu secretaria virtual", ["Tu Gmail ordenado por prioridad y respuestas redactadas con IA", "Agenda de visitas, llamadas y tareas con recordatorios y resumen a las 08:00", "Órdenes por voz o texto: «Nuvli, agenda una visita con María el viernes a las 10»"]],
};

export function FuncionBloqueada({ funcion }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [titulo, ventajas] = INFO[funcion];
  const plan = minimo(funcion);
  const colab = user?.team_role === "colaborador";
  return (
    <Card className="max-w-2xl mx-auto mt-6 p-8 text-center rounded-2xl animate-in fade-in-0 slide-in-from-bottom-2 duration-300" data-testid={`funcion-bloqueada-${funcion}`}>
      <div className="w-14 h-14 mx-auto rounded-2xl bg-[#00B4CC]/10 flex items-center justify-center mb-4"><Lock className="w-7 h-7 text-[#00B4CC]" /></div>
      <h1 className="font-heading text-2xl sm:text-3xl font-extrabold text-[#1B2B4B]">{titulo}</h1>
      <p className="text-slate-500 mt-2" data-testid="funcion-bloqueada-texto">
        Tu {NOMBRE_PLAN[user?.plan_efectivo] || "Plan Gratuito"} no incluye esta función. Está disponible desde el {NOMBRE_PLAN[plan]}.
      </p>
      <ul className="text-left inline-block mt-5 space-y-2">
        {ventajas.map((v) => <li key={v} className="flex items-start gap-2 text-sm text-slate-700"><Check className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0" />{v}</li>)}
      </ul>
      <div className="mt-6">
        {colab ? <p className="text-sm text-slate-500" data-testid="funcion-bloqueada-colab">Pide al administrador de la cuenta que mejore el plan.</p> : (
          <Button onClick={() => navigate(`/planes?plan=${plan}`)} className="rounded-xl bg-[#1B2B4B] hover:bg-[#13203A] text-white transition-colors" data-testid="funcion-bloqueada-cta">
            <Sparkles className="w-4 h-4 mr-1.5" /> Ver el {NOMBRE_PLAN[plan]}
          </Button>
        )}
      </div>
    </Card>
  );
}

export function ConFuncion({ funcion, children }) {
  const { user } = useAuth();
  return tiene(user, funcion) ? children : <FuncionBloqueada funcion={funcion} />;
}
